module.exports = __webpack_public_path__ + "img/cave144.adb56227.jpg";